import React from 'react'
// import PropTypes from 'prop-types'

const Settings = () => <div className="bg-light-100">Settings</div>

Settings.propTypes = {}
Settings.defaultProps = {}

export default Settings
